module.exports = __webpack_public_path__ + "static/media/icon_perfil.6962a7b8.svg";